'use client'
import { __awaiter } from '../../_virtual/_tslib.js';
import { disconnect } from 'starknetkit';
import StarknetWalletConnector from '../starknetWalletConnector.js';

class ArgentXBase extends StarknetWalletConnector {
    constructor() {
        super(...arguments);
        this.canConnectViaCustodialService = true;
    }
    isInstalledOnBrowser() {
        return false;
    }
    getAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield this.connect();
            return Promise.resolve((_a = this.getWallet()) === null || _a === void 0 ? void 0 : _a.selectedAddress);
        });
    }
    endSession() {
        return __awaiter(this, void 0, void 0, function* () {
            yield disconnect();
            this.wallet = undefined;
        });
    }
    getWallet() {
        return this.wallet;
    }
    getSelectedNodeUrl() {
        var _a, _b, _c, _d;
        if (!this.starknetNetworks || this.starknetNetworks.length !== 1) {
            return undefined;
        }
        return (((_b = (_a = this.starknetNetworks) === null || _a === void 0 ? void 0 : _a[0].privateCustomerRpcUrls) === null || _b === void 0 ? void 0 : _b[0]) ||
            ((_d = (_c = this.starknetNetworks) === null || _c === void 0 ? void 0 : _c[0].rpcUrls) === null || _d === void 0 ? void 0 : _d[0]));
    }
    getSelectedNetworkName() {
        var _a;
        if (!this.starknetNetworks || this.starknetNetworks.length !== 1) {
            return undefined;
        }
        const chainId = (_a = this.starknetNetworks) === null || _a === void 0 ? void 0 : _a[0].chainId;
        return this.mapChainIdToNetworkName(chainId);
    }
}

export { ArgentXBase as default };
